import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC8oTTINkUuMEdPwuBOrwgsHlXP8xKldkU",
  authDomain: "sbm-udhayam.firebaseapp.com",
  projectId: "sbm-udhayam",
  storageBucket: "sbm-udhayam.firebasestorage.app",
  messagingSenderId: "824102967357",
  appId: "1:824102967357:web:a1fd1449748a4540f77254",
  measurementId: "G-M5ZMHXK3HN"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);